import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { Widget } from '../../../../Widget'
import { RentalPortalBlockDisabledEditButton } from '../../../RentalPortalBlockDisabledEditButton'
import { useApplicantProfileContext } from '../../RentalPortalApplicantProfile.hooks'
import {
  getCanEditApplicantBlock,
  getIsApplicantWidgetSkeleton,
} from '../RentalPortalApplicantProfileTabOverview.utils'

import { QA_NAME_APPLICANT_MATCHING_WIDGET } from './ApplicantMatchingWidget.constants'
import { ApplicantMatchingWidgetContent } from './ApplicantMatchingWidgetContent'

function ApplicantMatchingWidget() {
  const { t } = useTranslation()

  const { applicantData, isInitiated } = useApplicantProfileContext()

  const editActionsProps = getCanEditApplicantBlock(applicantData)
    ? EMPTY_OBJECT
    : {
        EditButton: RentalPortalBlockDisabledEditButton,
        editButtonProps: {
          tooltipKey: 'RentalPortal.ApplicantEditNotAllowedTooltipKey',
        },
      }

  return (
    <Widget
      headerProps={{
        contentProps: {
          actionsProps: editActionsProps,
        },
      }}
      isSkeleton={getIsApplicantWidgetSkeleton({ applicantData, isInitiated })}
      qaName={QA_NAME_APPLICANT_MATCHING_WIDGET}
      title={t('RentalPortal.ApplicantProfileMatchingTitleKey')}
    >
      <ApplicantMatchingWidgetContent />
    </Widget>
  )
}

export default ApplicantMatchingWidget
